import Checkbox from '@mui/material/Checkbox'
import { styled } from '@mui/material/styles'

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  '&.MuiCheckbox-root': {
    color: theme.palette.text['label-default'],

    '&.error': {
      color: theme.palette.text.error,
    },

    '&:hover .MuiTouchRipple-child': {
      backgroundColor: theme.palette.background.subtle,
    },
  },

  '& .MuiIconButton-label': {
    zIndex: 1, // move svg icon above Ripple to avoid opacity
  },

  '&.Mui-FocusVisible .MuiTouchRipple-child': {
    backgroundColor: theme.palette.control.focusVisible.background,
  },

  '&.Mui-checked': {
    '& .MuiTouchRipple-child': {
      backgroundColor: theme.palette.action['secondary-bg-hover'],
    },

    '& .MuiSvgIcon-root': {
      fill: theme.palette.text.brand,
    },
  },

  '&.Mui-disabled .MuiSvgIcon-root': {
    fill: theme.palette.text.disabled,
  },

  '&.Mui-checked.Mui-disabled .MuiSvgIcon-root': {
    fill: theme.palette.action['secondary-bg-hover'],
  },
}))
